import React from 'react'
export function Toolbar (props) {
    return (<div className="toolbar sizing">
        {props.children}
    </div>)
}

export default Toolbar


// WEBPACK FOOTER //
// ./src/layout/components/toolbar/Toolbar.js